module.exports = __webpack_public_path__ + "static/media/puzzle-right.ef3a63fa.png";